// extracted by mini-css-extract-plugin
export var component = "GridMenuLink-module--component--m5LMt";
export var label = "GridMenuLink-module--label--e4bG9";